// 手机报团
import groupIndex from '@/views/travel/group/index'

const mtRoutes = Array.from({ length: 29 }, (_, i) => ({
  path: `group/mt/index${i + 1}`,
  name: `group/mt/Index${i + 1}`,
  component: () => import(`@/views/travel/group/mt/index${i + 1}.vue`)
}))
const xcRoutes = Array.from({ length: 34 }, (_, i) => ({
  path: `group/xc/index${i + 1}`,
  name: `group/xc/Index${i + 1}`,
  component: () => import(`@/views/travel/group/xc/index${i + 1}.vue`)
}))

export default {
  path: '/travel',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'group/index',
      name: 'groupIndex',
      component: groupIndex
    },
    // 手机报团，开始
    ...mtRoutes,
    ...xcRoutes
    // 手机报团，结束

  ]
}
